import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './Button';
export const PricingSection = () => {
  return <section id="pricing" className="py-10 px-4 md:px-8 bg-brand-green text-white relative overflow-hidden" data-id="element-171">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-gold via-transparent to-transparent" data-id="element-172"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-174">
          <p className="text-xl md:text-2xl font-serif italic opacity-90 leading-relaxed" data-id="element-175">
            "No vas a pagar $643. Ni siquiera la mitad. Porque mi misión es que
            ninguna mujer pase por este proceso a ciegas como me tocó a mí..."
          </p>

          <div className="bg-white text-brand-charcoal p-8 md:p-12 rounded-3xl shadow-2xl transform scale-105" data-id="element-176">
            <h3 className="text-sm font-bold text-brand-green uppercase tracking-widest mb-4" data-id="element-177">
              ACCEDE HOY POR SOLO
            </h3>

            <div className="flex justify-center items-baseline gap-2 mb-6" data-id="element-178">
              <span className="text-6xl md:text-7xl font-bold text-brand-green" data-id="element-179">
                $37
              </span>
            </div>

            <p className="text-sm md:text-base text-brand-charcoal/70 font-medium mb-4 bg-brand-cream py-2 px-4 rounded-full inline-block" data-id="element-180">
              Un pago único. Acceso de por vida a todas las actualizaciones
              futuras.
            </p>

            <p className="text-sm md:text-base text-brand-green font-semibold mb-6" data-id="element-181">
              Incluye 15 Bonos Exclusivos de Regalo valorados en $643.{' '}
              <a href="#bonuses" onClick={e => {
              e.preventDefault();
              document.getElementById('bonuses')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="underline text-brand-gold hover:text-brand-greenLight transition-colors cursor-pointer" data-id="element-182">
                Más información
              </a>
            </p>

            <CTAButton href="https://dobolia.com/cart/64387670802781:1" className="w-full text-lg py-5 shadow-lg" data-id="element-183">
              SÍ, QUIERO MI PAZ HORMONAL — ACCESO POR $37
            </CTAButton>

            <p className="mt-4 text-xs text-brand-charcoal/50 uppercase tracking-wider" data-id="element-184">
              Oferta de lanzamiento por tiempo limitado
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};